import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3b812f61"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "kt_wrapper",
  class: "flex-column flex-row-fluid wrapper flex flex-col min-h-screen"
}
const _hoisted_2 = {
  id: "kt_content",
  class: "content flex-grow d-flex flex-column flex-column-fluid w-auto bg-gray-100"
}
const _hoisted_3 = {
  id: "kt_main",
  class: "flex-col w-auto"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_KTHeader = _resolveComponent("KTHeader")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_KTFooter = _resolveComponent("KTFooter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_KTHeader),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_view)
      ])
    ]),
    _createVNode(_component_KTFooter)
  ]))
}